import { Component, Input, OnInit, ViewChildren } from "@angular/core";
import { from, mergeMap } from "rxjs";
import { BaseUrlConstantsService } from "../../../app/services/base-url-constants.service";
import { PowerTrainService } from "../../../app/services/powertrain.service";
import { CommonModule } from "@angular/common";
import { MatTooltipModule } from "@angular/material/tooltip";

@Component({
  selector: "app-powertrain-sensors-table",
  templateUrl: "./powertrain-sensors-table.component.html",
  styleUrls: ["./powertrain-sensors-table.component.scss"],
  standalone:true,
  imports:[CommonModule,MatTooltipModule]
})
export class PowertrainSensorsTableComponent implements OnInit {
  sensorLatestValuesUrl = BaseUrlConstantsService.MONITORING_SENSOR_API;
  @ViewChildren("tooltip") tooltips;

  @Input("idsData") idsData: any = [];
  @Input("client_id") client_id: any = [];
  extraRow = [];
  constructor(private service: PowerTrainService) {}

  ngOnInit(): void {
    this.fetchSensorsLatestData();
    console.log(this.idsData);
  }

  fetchSensorsLatestData() {
    // Use RxJS `from` to convert the array into an observable stream
    from(this.idsData)
      .pipe(
        mergeMap((item: any) =>
          this.service
            .fetchSensorsLatestData(
              `${this.sensorLatestValuesUrl}${item.asset_id}/${
                item.inventory_id
              }?userId=${this.client_id}`
              // `${this.sensorLatestValuesUrl}${item.inventory_id}/${
              //   item.asset_id
              // }?userid=${localStorage.getItem("user_id")}`
            )
            .then((data: any) => {
              return { ...item, sensor: data.newMetricData, loader: false };
            })
            .catch((err) => {
              console.error(`Error fetching data for ${item.asset_id}`, err);
              return { ...item, sensor: [], loader: true }; // Fallback to empty sensor data on error
            })
        )
      )
      .subscribe({
        next: (updatedItem) => {
          // Find the index of the item being updated
          const index = this.idsData.findIndex(
            (element) => element.asset_id === updatedItem.asset_id
          );
          if (index !== -1) {
            this.idsData[index] = updatedItem; // Update the array with the new data
          }
          // console.log('Updated idsData:', this.idsData); // Log the updated array
        },
        error: (err) => {
          console.error("Error during data fetching:", err);
        },
        complete: () => {
          if (this.idsData.length == 1) this.extraRow = [1, 2, 3, 4, 5, 6];
          else if (this.idsData.length == 2) this.extraRow = [1, 2, 3, 4, 5];
          else if (this.idsData.length == 3) this.extraRow = [1, 2, 3, 4];
          else if (this.idsData.length == 4) this.extraRow = [1, 2, 3];
          else if (this.idsData.length == 5) this.extraRow = [1, 2];
          else this.extraRow = [1];
        },
      });
  }

  get_H_info(){
    return 'Velocity Thresholds as per ISO 10816-3 or customer defined specific thresholds as per their process.'
  }
  get_Temo_info(){
    return 'Temperature Thresholds as per  IEEE 841 or customer defined specific thresholds as per their process.'
  }
  get_Ultra_info(){
    return 'Machine acoustics thresholds as per the ISO 29821 or customer defined specific thresholds as per their process.'
  }
  get_Audible_info(){
    return 'Values are calculated for 1.5m from surface of asset.'
  }
}
